import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { finalize } from 'rxjs/operators';
import { SnackbarService } from '@app/core/services/snackbar.service';
import { OverlayService } from '@app/shared/components/overlay/overlay.service';
import { ReportDesignerService } from '../../services/report-designer.service';
import { ReportStatus } from '../../models/report-designer.model';

@Component({
  selector: 'app-change-report-status-dialog',
  templateUrl: './change-report-status-dialog.component.html',
  styleUrls: ['./change-report-status-dialog.component.scss']
})
export class ChangeReportStatusDialogComponent {
  public reportId: string;
  public reportName: string;
  public reportStatuses: ReportStatus[];
  public selectedStatusId: string;

  constructor(
    private dialogRef: MatDialogRef<ChangeReportStatusDialogComponent>,
    private snackbarService: SnackbarService,
    private overlayService: OverlayService,
    private reportDesignerService: ReportDesignerService,
    @Inject(MAT_DIALOG_DATA) data
  ) {
    this.reportId = data.reportId;
    this.reportName = data.reportName;
    this.reportStatuses = data.reportStatuses || [];
    this.selectedStatusId = data.currentStatusId;
  }

  close(): void {
    this.dialogRef.close();
  }

  save(): void {
    if (!this.selectedStatusId) {
      this.dialogRef.close();
      return;
    }

    this.overlayService.show();

    this.reportDesignerService.changeReportStatus(this.reportId, this.selectedStatusId)
      .pipe(finalize(() => this.overlayService.hide()))
      .subscribe({
        next: () => {
          this.snackbarService.openSnackBar('Report status updated successfully', 'clear', 'success');
          this.dialogRef.close(true);
        },
        error: () => {
          this.snackbarService.openSnackBar('Unable to update report status', 'clear', 'warn');
        }
      });
  }
}
